'use client'

import Svg from '@material-symbols/svg-400/outlined/check-fill.svg'
import { type SvgIconProps } from '@mui/material'
import { MaterialSymbol } from './MaterialSymbol'

export function CheckIcon(props: SvgIconProps) {
  return <MaterialSymbol icon={Svg} {...props} />
}
